// extracted by mini-css-extract-plugin
export default {"benefit":"benefit___g5Zh8","benefit_title":"benefit_title___W8vUW","benefit_block":"benefit_block___V_BDv","benefit_item":"benefit_item___DZE6f"};